import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";

export default function Subscription() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["subscription"], queryFn: async () => (await api.get("/subscription")).data });

  const choose = async (plan) => {
    try {
      await api.put("/subscription", { plan });
      toast.success(`Plan set to ${plan}`);
      qc.invalidateQueries({ queryKey: ["subscription"] });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Update failed"); }
  };

  if (!data) return <div className="p-8 text-neutral-400">Loading…</div>;
  const current = data.subscription?.plan;

  return (
    <div className="h-full overflow-y-auto p-6 lg:p-8" data-testid="subscription">
      <PageHeader title="Franchise / subscription" subtitle="Outlet seats and plan limits for your ojent account" />
      <p className="text-sm text-neutral-500 mb-4">Current: <b className="capitalize">{current}</b> · {data.subscription?.seats} seats · {data.subscription?.outlets_allowed} outlets · {data.subscription?.status}</p>
      <div className="grid md:grid-cols-3 gap-4 max-w-4xl">
        {(data.plans || []).map((p) => (
          <div key={p.id} className={`kul-card p-5 ${current === p.id ? "ring-2 ring-[var(--kul-primary)]" : ""}`}>
            <div className="font-display text-xl font-800">{p.name}</div>
            <div className="text-3xl font-bold mt-2">₹{p.price_inr}<span className="text-sm font-normal text-neutral-400">/mo</span></div>
            <ul className="text-sm text-neutral-500 mt-3 space-y-1">
              <li>{p.outlets} outlet(s)</li>
              <li>{p.seats} staff seats</li>
            </ul>
            <Button className="w-full mt-4 bg-[var(--kul-primary)] text-white" onClick={() => choose(p.id)} disabled={current === p.id}>
              {current === p.id ? "Current plan" : "Select"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
